<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="laudoSinalizadorLoteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Sinalizador</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="form-row">
                            <div class="col col-12 col-md-8 d-flex flex-column">
                                <az-input
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'S', search: 'Substituir' },
                                        { id: 'I', search: 'Incluir' },
                                        { id: 'R', search: 'Remover' },
                                    ]" 
                                    optionsData="id"
                                    v-model="sinalizador_opcao" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    type="select"
                                    placeholder="Tipo de Etiqueta..."
                                    optionsMode="aql"
                                    service="tipo_etiqueta_amostras.index"
                                    optionsData2="id_tipo_etiqueta_amostra"
                                    optionsName="tipo_etiqueta_amostras.index.gerar"
                                    :optionsParm="{ ativos: true, geracao: true }"
                                    v-model="tipo_etq" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-4" v-if="sinalizador_opcao != 'I'">
                                <az-input 
                                    :label="sinalizador_opcao == 'S' ? 'De' : 'Remover'"
                                    placeholder="Sinalizador..."
                                    type="select" 
                                    optionsMode="aql"
                                    service="sinalizadores.index"
                                    :optionsParm="{ ativos: true }"
                                    optionsData="id_sinalizador_atendimento"
                                    required
                                    :validate="validate"
                                    v-model="origem_sinalizador">
                                </az-input>
                            </div>
                        
                            <div class="col col-12 col-md-4" v-if="sinalizador_opcao != 'R'">
                                <az-input 
                                    :label="sinalizador_opcao == 'S' ? 'Para' : 'Novo'"
                                    placeholder="Sinalizador..."
                                    type="select" 
                                    optionsMode="aql"
                                    service="sinalizadores.index"
                                    :optionsParm="{ ativos: true }"
                                    optionsData="id_sinalizador_atendimento"
                                    required
                                    :validate="validate"
                                    v-model="novo_sinalizador">
                                </az-input>
                            </div>

                            <div class="col col-12 col-md-4" v-if="sinalizador_opcao != 'R'">
                                <az-input 
                                    label="Observações"
                                    placeholder="Observações..."
                                    v-model="novo_observacoes">
                                </az-input>
                            </div>
                        </div>

                        <template v-if="lista_filtrada && lista_filtrada.length">

                            <az-input
                                sizing="sm"
                                icon="fa fa-search"
                                class="mt-3"
                                placeholder="Informar Atendimento..."
                                v-model="pesquisa"
                                @onEnter="selecionar_atendimento()" />

                            <table class="table table-sm table-hover small mt-3 cabecalho-fixo-modal">
                                <thead>
                                    <tr>
                                        <th>
                                            <a href="#" @click.prevent="toggle_selecionados()">
                                                <i class="fa-solid fa-square"></i>
                                            </a>
                                        </th>
                                        <th>
                                            Paciente
                                            <span class="badge badge-secondary ml-2">{{ selecionados.length }}</span>
                                        </th>
                                        <th>#</th>
                                        <th>Procedimento</th>
                                        <th>Material</th>
                                        <th>Solicitante</th>
                                        <th>Responsáveis</th>
                                        <th>Sinalizador</th>
                                        <th>
                                            <grupo-etq-amostras :atp="cassetes_consolidados" color="dark" />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, iix) in lista_filtrada" :key="iix" :class="!item.sel ? 'table-secondary' : ''">
                                        <td>
                                            <input type="checkbox" v-model="item.sel" /> 
                                        </td>
                                        <td>
                                            {{ item.atendimento_procedimento.atendimento.paciente.st_nome }}
                                        </td>
                                        <td>
                                            #{{ item.atendimento_procedimento.id_atendimento }}
                                        </td>
                                        <td>
                                            {{ item.atendimento_procedimento.procedimento.search }}
                                        </td>
                                        <td>
                                            <span v-if="item.atendimento_procedimento.amostra">
                                                {{ item.atendimento_procedimento.amostra.search }}
                                                <template v-if="item.atendimento_procedimento.amostra.js_classes && item.atendimento_procedimento.amostra.js_classes.length == 1">
                                                    <span class="badge badge-success ml-1" v-for="(classe, icx) in item.atendimento_procedimento.amostra.js_classes" :key="icx">
                                                        {{ classe }}
                                                    </span>
                                                </template>
                                            </span>
                                        </td>
                                        <td style="max-width: 100px;">
                                            <div class="text-truncate" v-if="item.atendimento_procedimento.atendimento && item.atendimento_procedimento.atendimento.medico_solicitante">
                                                {{ item.atendimento_procedimento.atendimento.medico_solicitante.st_nome }}
                                            </div>
                                        </td>
                                        <td>
                                            {{ lista_resps(item) }}
                                        </td>
                                        <td>
                                            <i class="ml-1" 
                                                v-for="(sinal, isx) in item.sinals" :key="isx"
                                                :class="( sinal.sinalizador.st_icon ? sinal.sinalizador.st_icon : 'fas fa-flag' ) + ' text-' + sinal.sinalizador.st_cor"
                                                data-toggle2="tooltip" data-placement="top" 
                                                :title="sinal.sinalizador.search"></i>
                                        
                                            <i class="ml-1" 
                                                :class="( item.atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_icon ? item.atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' text-' + item.atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.st_cor"
                                                data-toggle2="tooltip" data-placement="top" 
                                                :title="item.atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento.search" 
                                                v-if="item.atendimento_procedimento.atendimento.marcacao && item.atendimento_procedimento.atendimento.marcacao.sinalizador_atendimento"></i>
                                        </td>
                                        <td>
                                            <grupo-etq-amostras :atp="item.atendimento_procedimento" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import GrupoEtqAmostras from './GrupoEtqAmostras.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            tipo_etq: "",
            validate: false, 
            lista: null,
            servidor_impressao: "", 
            pesquisa: "", 
            sinalizador_opcao: 'S',
            origem_sinalizador: "",
            novo_sinalizador: "",
            novo_observacoes: "",
        }       
    },

    components: { 
        AzInput,
        AzSubmit, 
        GrupoEtqAmostras, 
    },

    computed: { 
        is_tipo_lamina: function () { 

            if ( this.tipo_etq && this.tipo_etq.search && this.tipo_etq.search.startsWith('Lâmina') ) { 
                return true;
            }

            return false; 

        },

        lista_filtrada: function () { 
            if ( !this.lista ) { 
                return []; 
            }

            if ( !this.tipo_etq ) { 
                return this.lista; 
            }

            if ( this.is_tipo_lamina ) { 
                return this.lista.filter(item => ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.length ));
            }

            return this.lista.filter(item => ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.length ) 
                && ( !this.tipo_etq || ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.find(ge => ge.tipo_etiqueta && ge.tipo_etiqueta.id_tipo_etiqueta_amostra == this.tipo_etq.id_tipo_etiqueta_amostra) ) )); 
        },

        selecionados: function () {
            if ( !this.lista_filtrada || !this.lista_filtrada.length )
                return [];

            return this.lista_filtrada.filter(item => item.sel);
        },

        cassetes_consolidados: function () {
            return { 
                grupo_etq_amostras: _.values(
                    this.selecionados.reduce((acc, item) => {
                        if ( item.atendimento_procedimento && item.atendimento_procedimento.grupo_etq_amostras && item.atendimento_procedimento.grupo_etq_amostras.length ) { 
                            item.atendimento_procedimento.grupo_etq_amostras.forEach(ge => {
                                if ( !_.get(acc, _.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')) ) { 
                                    acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')] = _.cloneDeep(ge);
                                } else if ( ge.qt_itens ) { 
                                    acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')].qt_itens = acc[_.get(ge, 'tipo_etiqueta.id_tipo_etiqueta_amostra')].qt_itens + ge.qt_itens;
                                }
                            });
                        }
                        return acc;
                    }, {})
                )
            };
        },
    },

    methods: { 
        selecionar_atendimento () { 

            let encontrado = false; 

            this.lista_filtrada.forEach(item => {
                if ( this.pesquisa && this.pesquisa.trim().length ) { 
                    if ( item.atendimento_procedimento && item.atendimento_procedimento.id_atendimento == parseInt(this.pesquisa.trim()) ) { 
                        item.sel = true;
                        encontrado = true; 
                    }
                }
            });

            if ( !encontrado ) { 
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Atendimento não encontrado na lista: ' + this.pesquisa,
                    life: 3000
                });
            }

            this.pesquisa = null;

            this.$nextTick(() => {
                this.pesquisa = "";
            });

        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'laudos', 
                func: 'atualizar_sinalizador_lote_ap',
                dados: { 
                    id_laudos: this.selecionados.map(item => item.id_laudo), 
                    id_sinalizador_origem: this.origem_sinalizador,
                    id_sinalizador_destino: this.novo_sinalizador,
                    opcao: this.sinalizador_opcao,
                    obs: this.novo_observacoes,
                },
                modal: 'laudoSinalizadorLoteModal',
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        toggle_selecionados() {
            let lista = this.lista_filtrada;

            let opcao = lista.find(ld => !ld.sel);

            lista.forEach(ld => {
                ld.sel = opcao;
            });
        },

        abrir (lista) { 
            this.validate = false; 
            let nova_lista = _.cloneDeep(lista);

            if ( !nova_lista ) { 
                nova_lista = [];
            } else { 
                nova_lista = nova_lista.filter(item => item.atendimento_procedimento); 
            }

            this.lista = nova_lista; 

            $('#laudoSinalizadorLoteModal').modal('show');
        },

        lista_resps (laudo) { 
            let lista = [];

            if ( laudo && laudo.resps && laudo.resps.length ) { 
                lista = laudo.resps.filter(item => item.fl_ativo)
                    .map(item => item.usuario ? item.usuario.st_login : '---' );
            }

            return lista.join(', ');
        },
    }
}
</script>
